<template>
    <!--加掛申請畫面-->

        <v-card>
            <v-toolbar style="max-height: 48px!important;" dark dense color="tertiary" class="v-toolbar--dense">
                <v-toolbar-title> 門診加掛申請單</v-toolbar-title>

                <v-spacer></v-spacer>
                <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-toolbar>
            <v-card-text  style="padding: 0px">
                <v-flex row wrap xs12 sm12 md12 lg12 ml-2 mr-2>

                    <v-flex xs12 sm12 md12 lg12 ml-0 mt-1 pr-3 pl-3>
                        <v-flex v-html="errorContent"></v-flex>

                        <v-container style="padding: 0px">
                            <v-row class="row--dense">

                                <!--<v-col cols="12" sm="12" md="8" style="text-align: right">-->
                                <v-col cols="12" sm="12" md="6" lg="6" class="d-inline-flex">
                                    <span  class="regLabel">申請看診日期</span>
                                    <v-text-field
                                            readonly
                                            ref="viewDate"
                                            v-model="appDateInfo"
                                            style="display: inline-block"
                                            class="regInput"
                                            hide-details
                                            label="申請看診日期"
                                            solo
                                    ></v-text-field>
                                    <!--<v-text-field-->
                                    <!--readonly-->
                                    <!--ref="apn"-->
                                    <!--v-model="apnName"-->
                                    <!--style="display: inline-block"-->
                                    <!--class="regInput"-->
                                    <!--hide-details-->
                                    <!--label="時段"-->
                                    <!--solo-->
                                    <!--&gt;</v-text-field>-->
                                    <!--<v-text-field-->
                                    <!--readonly-->
                                    <!--ref="divName"-->
                                    <!--v-model="divName"-->
                                    <!--style="display: inline-block"-->
                                    <!--class="regInput"-->
                                    <!--hide-details-->
                                    <!--label="科別"-->
                                    <!--solo-->
                                    <!--&gt;</v-text-field>-->
                                </v-col>


                                <v-col cols="12" sm="12" md="6" lg="6" style="text-align: right" class="d-inline-flex">
                                    <span  class="regLabel ">主治醫師</span>
                                    <v-text-field
                                            readonly
                                            ref="doctorNo"
                                            v-model="docInfo"
                                            style="display: inline-block"
                                            class="regInput"
                                            hide-details
                                            solo
                                    ></v-text-field>
                                    <!--<v-text-field-->
                                    <!--readonly-->
                                    <!--ref="doctorName"-->
                                    <!--v-model="doctorName"-->
                                    <!--style="display: inline-block"-->
                                    <!--class="regInput"-->
                                    <!--hide-details-->
                                    <!--solo-->
                                    <!--&gt;</v-text-field>-->
                                </v-col>

                                <v-col cols="12" sm="12" md="6" lg="6" style="text-align: right" class="d-inline-flex">
                                    <span  class="regLabel hintRed">身分證號*</span>
                                    <v-text-field
                                            hide-details
                                            ref="idNo"
                                            v-model="idNo"
                                            style="display: inline-block"
                                            class="regInput"
                                            solo
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="6" lg="6" style="text-align: right" class="d-inline-flex">
                                    <span  class="regLabel hintRed">民國生日*</span>
                                    <v-text-field
                                            ref="birthDate"
                                            v-model="birthDate"
                                            style="display: inline-block"
                                            class="regInput"
                                            label="例0950101"
                                            clearable
                                            type="number"
                                            hint="例0950101"
                                            solo
                                            hide-details
                                    ></v-text-field>
                                </v-col>


                                <v-col cols="12" sm="12" md="6" lg="6" style="text-align: right" class="d-inline-flex">
                                    <span  class="regLabel hintRed">姓名*</span>
                                    <v-text-field
                                            hide-details
                                            ref="ptName"
                                            v-model="ptName"
                                            style="display: inline-block"
                                            class="regInput"
                                            solo
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="6" lg="6" style="text-align: right" class="d-inline-flex">
                                    <span  class="regLabel hintRed">連絡電話*</span>
                                    <v-text-field
                                            hide-details
                                            ref="telNo"
                                            v-model="telNo"
                                            style="display: inline-block"
                                            class="regInput"
                                            solo
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" md="12" lg="12" style="text-align: right" class="d-inline-flex">
                                    <span  class="regLabel hintRed">加掛目的*</span>
                                    <v-radio-group v-model="addRegRes" row hide-details >

                                        <v-radio @click="changeAddRegRes(item)" v-for="(item,index) in addRegResList" :key="index" :label="item.value2" :value='item.value1' color="black"></v-radio>
                                    </v-radio-group>

                                </v-col>
                                <v-col cols="12" sm="12" md="12" lg="12" style="text-align: right" class="d-inline-flex">


                                    <v-text-field
                                            @click="clickNoteOther"
                                            :readonly="addRegRes==''"
                                            hide-details
                                            ref="noteOther"
                                            v-model="noteOther"
                                            style="display: inline-block"
                                            class="regInput"
                                            solo
                                    ></v-text-field>
                                </v-col>


                            </v-row>
                        </v-container>







                    </v-flex>

                    <v-container>
                        <v-row class="row--dense">
                            <v-col>
                                <p style="font-weight: bold;font-size: 1.2rem;color: black" v-html="addRegNote"></p>
                            </v-col>
                        </v-row>
                    </v-container>

                    <!--<v-flex class="xs12 sm12 md4 lg4 pl-1 mt-1">-->

                    <!---->
                    <!--</v-flex>-->




                </v-flex>
            </v-card-text>

            <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
                <v-spacer></v-spacer>
                <v-btn  @click.native="closeDialog">取消</v-btn>
                <v-btn  @click.native="save">確定加掛</v-btn>
            </v-card-actions>

            <v-dialog v-model="errorDialog"
                      persistent
                      width="50%"
                      xs6 sm6 md6
                      value="false"
                      scrollable>
                <alert-win @closeDialog="closeErrorDialog" @confirm="errConfirm" :alery-type="aleryType"  :alert-title="errorTitle" :alert-msg="errorContent" ></alert-win>
            </v-dialog>

            <v-dialog
                    v-model="checkLoading"
                    hide-overlay
                    persistent
                    width="300"
            >
                <v-card
                        color="primary"
                        dark
                >
                    <v-card-text>
                        加掛申請中，請稍後
                        <v-progress-linear
                                indeterminate
                                color="white"
                                class="mb-0"
                        ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <!-- 我是 snackbar -->
            <v-snackbar
                    :timeout="snTimeout"
                    v-model="snStatus">
                {{snText}}
            </v-snackbar>

        </v-card>






</template>

<script>
    import AlertWin from '../inursingsys/AlertWin'
    export default {
        name: "AddReg",
        components:{AlertWin},
        data() {
            return {
                appDateInfo:'',
                docInfo:'',
                checkLoading:false,
                viewDate:'',
                apn:'',
                apnName:'',
                divName:'',
                doctorNo:'',
                doctorName:'',
                idNo:'',
                birthDate:'',
                ptName:'',
                telNo:'',
                noteOther:'',//加掛目的
                addRegNote:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                errorDialog:false,
                errorTitle: '',
                errorContent:'',
                aleryType:'error',
                addRegResList:'',
                addRegRes:'',
            }
        },
        mounted: function() {
            if (this.$route.query.viewDate){
                this.viewDate = this.$route.query.viewDate;
                this.apn = this.$route.query.apn;
                this.apnName = this.transApn(this.$route.query.apn);
                this.doctorNo = this.$route.query.doctorNo;
                this.doctorName = this.$route.query.doctorName;
                this.clinicNo = this.$route.query.clinicNo;
                this.divName =  this.$route.query.divName+" "+this.$route.query.clinicName;
                this.appDateInfo = this.viewDate+' '+this.apnName+' '+this.divName;
                this.docInfo = this.doctorNo+' '+this.doctorName;
            }

        },
        created(){
          this.axios_getSysAddregres();//查詢加掛理由清單
          this.axios_getRegNote(this.$route.query.divNo+","+this.$route.query.clinicNo+","+this.$route.query.doctorNo)
        },
        methods:{
            clickNoteOther(){
                if(this.addRegRes==''){
                    this.snStatus = true;
                    this.snText = "請先選擇加掛目的"
                }
            },
            changeAddRegRes(item){
                this.noteOther = item.value2;
            },
            transApn(apn){
                if(apn.toString()=="1"){
                    return "早上";
                }else if(apn.toString()=='2') {
                    return "下午";
                }else {
                    return "晚上";
                }
            },
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                let today  =  this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString().toString(),'date').replace(new RegExp("-", 'g'), "")
                let idNo = this.idNo==null||this.idNo==""?'':this.idNo;
                let ptName = this.ptName==null||this.ptName==""?'':this.ptName;
                let telNo = this.telNo==null||this.telNo==""?'':this.telNo;
                let birthDate = this.birthDate==null||this.birthDate==""?'':this.birthDate;
                let noteOther = this.noteOther==null||this.noteOther==""?'':this.noteOther;
                let addRegRes = this.addRegRes==null||this.addRegRes==""?'':this.addRegRes;
                if((this.$UtilityJs.transROC2YMD(this.viewDate))<=today){ //日期小於今天不得加掛
                    alert('加掛日期必須大於今天')
                }else if(idNo==''||ptName==''||telNo==''||birthDate==''||noteOther==''||addRegRes==''){
                    alert('請填寫必要欄位')
                }else{
                    let note01Flag = addRegRes=="01"?'Y':'N';
                    let note02Flag = addRegRes=="02"?'Y':'N';
                    let note03Flag = addRegRes=="03"?'Y':'N';
                    let noteOtherFlag = addRegRes=="00"?'Y':'N';
                    let addRegObj = {
                        idNo: idNo,
                        birthDate: birthDate,
                        appDate: this.$route.query.viewDate,
                        ptName: ptName,
                        doctorNo: this.$route.query.doctorNo,
                        divNo: this.$route.query.divNo,
                        apn:  parseInt(this.$route.query.apn),
                        contact: telNo,
                        note01Flag: note01Flag,
                        note02Flag: note02Flag,
                        note03Flag: note03Flag,
                        noteOtherFlag: noteOtherFlag,
                        noteOther: noteOther,
                        clinicNo: parseInt(this.$route.query.clinicNo)
                    }
                    this.$emit('save',addRegObj);
                }
                // axios_postRegAddNote

            },
            NextItem(nextId){
                this.$refs[nextId].focus();
            },
            closeErrorDialog(){
                this.errorDialog = false;
            },
            errConfirm(){
                this.closeErrorDialog();
            },
            axios_getSysAddregres (){ //加掛理由清單
                let url = '';
                this.addRegResList = [];
                    url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/LIST/ADDREGRES";

                    this.$http.get(url).then(response =>{
                        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                            this.addRegResList = response.data.resultSet;

                        }else{
                            this.addRegResList = [];

                        }


                    }).catch(error =>  {
                        try {
                            switch (error.response.status){
                                case 300:
                                case 400:
                                case 401:
                                    this.errorDialog = true;
                                    this.errorTitle = "訊息";
                                    this.errorContent = '<div style="color: red;font-size: 1.2rem;font-weight: bold">'+ error.response.data.message+'</div>';
                                    break;
                                case 404:
                                    this.errorDialog = true;
                                    this.errorTitle = "訊息";
                                    this.errorContent ="找不到頁面";
                                    break;
                                case 500:
                                    this.errorDialog = true;
                                    this.errorTitle = "訊息";
                                    this.errorContent = "伺服器錯誤";
                                    break;
                                default:
                                    this.errorDialog = true;
                                    this.errorTitle = "訊息";
                                    this.errorContent ='<div style="color: red;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
                            }
                        } catch(err) {
                          console.log(error)
                        }
                    });

            },

            axios_getRegNote (codeNo){ //掛號說明
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/ADDREG/"+codeNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        // this.addRegNote = response.data.resultSet[0].regNote;
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.addRegNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.addRegNote = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.addRegNote = '';
                    } catch(err) {
                        this.addRegNote = '';
                    }
                });
            },

        }
    }
</script>

<style scoped>

    .regLabel{
        margin-top: 12px!important;
        width: 120px;
        text-align: center;
    }

    .hintRed{
        color: red!important;
    }

</style>